import axios from 'axios';
import { captureAxiosError } from './sentry';

// Crea una instancia de Axios
const apiCliente = axios.create({
	baseURL: '/api',

	timeout: 20000, // Tiempo de espera máximo
});

// Interceptor de solicitudes para agregar el token solo si está en los headers
apiCliente.interceptors.request.use(
	(config) => {
		// Verifica si ya se pasó un token en los headers manualmente
		if (!config.headers.Authorization) {
			// Si no hay token en la petición, no hace nada
			return config;
		}
		return config;
	},
	(error) => {
		return Promise.reject(error);
	},
);

// Interceptor de respuestas para manejar errores globales
apiCliente.interceptors.response.use(
	(response) => {
		return response;
	},
	(error) => {
		if (error.response?.status === 401) {
			// Limpia el sessionStorage
			sessionStorage.clear();
		}

		captureAxiosError(error);

		// Rechaza el error original para que cada script pueda mostrar el mensaje del backend.
		return Promise.reject(error);
	},
);

export default apiCliente;
